export default "__VITE_PUBLIC_ASSET__db25dd0e__"